var React = require('react');

function ProshopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"f0","d":"M640 1664c0 35-12 66-37 91s-56 37-91 37-65-12-90-37-38-56-38-91 13-65 38-90 55-38 90-38 66 13 91 38 37 55 37 90zm896 0c0 35-12 66-37 91s-56 37-91 37-65-12-90-37-38-56-38-91 13-65 38-90 55-38 90-38 66 13 91 38 37 55 37 90zm128-1088v512c0 16-5 30-16 43s-24 19-41 21L563 1274l5 22 6 26c2 8 2 15 2 22 0 11-8 32-24 64h920c17 0 32 6 45 19s19 28 19 45-6 32-19 45-28 19-45 19H448c-17 0-32-6-45-19s-19-28-19-45c0-9 4-22 11-39s17-37 30-60l20-38-177-823H64c-17 0-32-6-45-19S0 465 0 448s6-32 19-45 28-19 45-19h256a66 66 0 0149 22c5 6 9 14 13 25l7 26 6 30 4 25h1201c17 0 32 6 45 19s19 28 19 45z"}));
}

ProshopInline.defaultProps = {"contentScriptType":"text/ecmascript","viewBox":"0 0 1664 2048"};

module.exports = ProshopInline;

ProshopInline.default = ProshopInline;
